import { FlexProps, Link } from '@chakra-ui/react';
import Button from '~/components/Button';
import ErrorPage from '~/components/ErrorPage';
import { routes } from '~/core/router';

interface Props {
  containerProps?: FlexProps;
  noFooter?: boolean;
}

const Error404: React.FC<Props> = ({
  containerProps = {},
  noFooter = false,
}) => {
  return (
    <ErrorPage containerProps={containerProps} noFooter={noFooter}>
      <ErrorPage.MainContent>
        <ErrorPage.Heading>404. Page not found</ErrorPage.Heading>
        <ErrorPage.Subheading>
          The page you’re looking for doesn’t exist or may have been removed.
        </ErrorPage.Subheading>
        <ErrorPage.Text>
          The link may be incorrect or the page may have been deleted.
        </ErrorPage.Text>
        <Link href={routes.root}>
          <Button colorScheme="primary">GO TO HOME PAGE</Button>
        </Link>
      </ErrorPage.MainContent>
      <ErrorPage.Image
        accentColor="#FFE6CC"
        srcSet="/images/404_img.jpg, /images/404_imgx2.jpg 2x, /images/404_imgx3.jpg 3x"
      />
    </ErrorPage>
  );
};

export default Error404;
